import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-PostFunction',
    templateUrl: './PostFunction.component.html'
})
export class PostFunctionComponent implements OnInit {

    consumerID: string;
    functions: [];

    data = {
        'consumerID' : this.consumerID,
        'functions' : this.functions,
        'plugin' : 'post-function'
    };

    constructor() { }
    PostFunction() {
    }

    ngOnInit() {
    }

}
